<div class="card">
  <div class="card-body" style="height: 600px;">

    <div class="h-100 d-flex align-items-center justify-content-center">
      <h1 class="text-center">ÎN LUCRU</h1>
    </div>

  </div>
</div>
